﻿const en = {
  draftLabel: 'Drafts',
  formDraftsListTitle: 'My drafts',
  formListTitle: 'All forms',
  formTitle: 'Forms',
  formSubtitle: 'Choose a form',
  chooseFormButton: 'Choose from the library',
  addButton: 'Add a form',
  updatedOn: 'Updated on {{date}}',
  entries_one: '{{count}} entry',
  entries: '{{count}} entries',
  selectedCount_one: '{{count}} form selected',
  selectedCount: '{{count}} forms selected',
};

export default en;
export type Translations = typeof en;
